<template>
	<div class="buy-giftcard">
		<!-- <v-container tag="section" fluid constrain>
			<h1 :class="[$vuetify.breakpoint.smAndUp && 'display-2']">Gavekort til frisør og velvære</h1>
		</v-container>-->

		<v-container tag="section" fluid constrain mb-12>
			<v-sheet :class="[$vuetify.breakpoint.mdAndUp ? 'pa-12' : 'pa-6']">
				<v-row :pa-6="$vuetify.breakpoint.mdAndUp">
					<!-- Title and information -->
					<v-col cols="12" md="5" v-if="!isCompleted" :pr-12="$vuetify.breakpoint.mdAndUp">
						<icon-title :src="icon" :width="$vuetify.breakpoint.mdAndUp ? 250 : 150" :size="$vuetify.breakpoint.mdAndUp ? '3rem' : '2rem'">Kjøp gavekort</icon-title>

						<p :class="[$vuetify.breakpoint.mdAndUp && 'lead pr-12']">
							Fixit.no-gavekortet kan brukes i alle salonger som du finner på Fixit.no. Mottakeren kan selv velge behandlingen eller produktene som frister mest. Gavekortet kan sendes direkte til
							mottakerens adresse, eller hjem til deg hvis du vil gi det personlig.
						</p>
					</v-col>

					<transition name="scroll-y-transition" mode="out-in">
						<!-- Buy giftcard -->
						<v-col md="7" key="buying" v-if="!isCompleted" style="position: relative">
							<v-stepper v-model="currentStep" vertical class="buy-giftcard-steps elevation-0" color="primary">
								<!-- #1: Giftcard options -->
								<v-stepper-step step="1" @click="goToStep(1)" id="buy-giftcard-step-1" :complete="currentStep > 1">
									Velg gavekort
									<small class="mt-1">Velg ønsket beløp og type gavekort</small>
								</v-stepper-step>

								<v-stepper-content step="1">
									<buy-giftcard-options v-model="currentStep" :giftcard.sync="giftcard" />
								</v-stepper-content>

								<!-- #2: Buyer and receiver info -->
								<v-stepper-step step="2" @click="goToStep(2)" id="buy-giftcard-step-2" :complete="currentStep > 2">
									Hvem vil du gi gavekortet til?
									<small class="mt-1">Legg inn en personlig hilsen</small>
								</v-stepper-step>

								<v-stepper-content step="2">
									<buy-giftcard-receiver-info v-model="currentStep" :giftcard.sync="giftcard" />
								</v-stepper-content>

								<!-- #3: Shipping -->
								<v-stepper-step step="3" @click="goToStep(3)" id="buy-giftcard-step-3" :complete="currentStep > 3">
									Levering
									<small class="mt-1">Fyll inn leveringsinformasjon</small>
								</v-stepper-step>

								<v-stepper-content step="3">
									<buy-giftcard-shipping v-model="currentStep" :giftcard.sync="giftcard" />
								</v-stepper-content>

								<!-- #4: Summary -->
								<v-stepper-step step="4" @click="goToStep(4)" id="buy-giftcard-step-4" :complete="currentStep > 4">
									Oppsummering
									<small class="mt-1">Fyll inn kortinformasjon</small>
								</v-stepper-step>

								<v-stepper-content step="4">
									<buy-giftcard-summary v-model="currentStep" :giftcard.sync="giftcard"></buy-giftcard-summary>
								</v-stepper-content>

								<!-- #5: Payment -->
								<v-stepper-step step="5" @click="goToStep(5)" id="buy-giftcard-step-5" :complete="currentStep > 5">
									Betaling
									<small class="mt-1">Fyll inn kortinformasjon</small>
								</v-stepper-step>

								<v-stepper-content step="5">
									<buy-giftcard-payment v-model="currentStep" :giftcard="giftcard" @submit="submitPurchase" :email="$user.email" />
								</v-stepper-content>
							</v-stepper>

							<v-overlay absolute :value="!!loading">
								<v-progress-circular indeterminate size="64"></v-progress-circular>
							</v-overlay>
						</v-col>

						<!-- Giftcard bought successfully -->

						<v-col cols="12" sm="12" key="completed" v-else class="buy-giftcard__completed">
							<buy-giftcard-completed :giftcard="giftcard" :value="currentStep" :requires-internal-handling="requiresInternalHandling" :email="$user.email" />
						</v-col>
					</transition>
				</v-row>
			</v-sheet>
		</v-container>
	</div>
</template>

<script>
import IconTitle from '@/components/IconTitle';

// Buy giftcard step components
import BuyGiftcardOptions from './components/BuyGiftcardOptions';
// import BuyGiftcardPreview from "./components/BuyGiftcardPreview";
import BuyGiftcardPayment from './components/BuyGiftcardPayment';
import BuyGiftcardReceiverInfo from './components/BuyGiftcardReceiverInfo';
import BuyGiftcardShipping from './components/BuyGiftcardShipping';
import BuyGiftcardSummary from './components/BuyGiftcardSummary';
import BuyGiftcardCompleted from './components/BuyGiftcardCompleted';
import { DeliveryMethodEnum } from '@/services/enums/deliveryMethods';

// Payment components
import { GiftCardService } from '@/services';
import { GiftCardPurchaseDetails, Snackbar } from '@/services/models';
export default {
	name: 'buy-giftcard-view',
	components: {
		IconTitle,
		BuyGiftcardOptions,
		// BuyGiftcardPreview,
		BuyGiftcardReceiverInfo,
		BuyGiftcardPayment,
		BuyGiftcardShipping,
		BuyGiftcardSummary,
		BuyGiftcardCompleted
	},
	data() {
		return {
			currentStep: 1,
			giftcard: null,
			icon: require('@/assets/img/app-icon.png'),
			loading: 0,
			requiresInternalHandling: false
		};
	},
	computed: {
		isCompleted() {
			return this.currentStep == -1;
		}
	},
	methods: {
		getDeliveryMethodFromurlParameter(deliveryMethod) {
			// Check if delivery type is valid
			// TODO: Use umbraco data for deliveryMethods
			switch (deliveryMethod) {
				case '0':
					break;
				case '1':
					break;
				//case '2':// Not yet enabled
				case '3':
					return deliveryMethod;
			}

			return '0';
		},
		getAmountFromUrlParameter(amount) {
			return parseInt(amount || 0);
		},
		goToStep(step) {
			// make sure we dont allow to step longer than possible/valid
			if (this.currentStep > step) {
				this.currentStep = step;
			}
		},

		purchaseCompleted(result) {
			try {
				// Send GA pageview purchase-completed
				this.giftcard.externalGiftcardId = result.externalGiftCardId;
				window.fixitPortalGiftcard = this.giftcard;
				this.$google.sendVirtualPageViewPortal(
					result.completed ? 'Kjøp gavekort - Betaling fullført' : 'Kjøp gavekort - Betaling fullført, men gavekort/ordre ikke prosessert enda.',
					'/kjop-gavekort/fullført'
				);

				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});

				this.requiresInternalHandling = result.requiresInternalHandling;
			} catch (err) {
				console.error(err);
			}
		},
		async submitPurchase(giftCardPurchaseDetails, paymentIntentId, shoppingCartId) {
			if (giftCardPurchaseDetails instanceof GiftCardPurchaseDetails || paymentIntentId) {
				this.loading++;

				if (giftCardPurchaseDetails && giftCardPurchaseDetails.deliveryMethod == DeliveryMethodEnum.PDF.id) {
					giftCardPurchaseDetails.deliveryPhoneNumber = window.CONFIG.user.mobile;
				}
				// Submit or confirm portal gift card purchase.
				const result = paymentIntentId ? await GiftCardService.ConfirmGiftCardPayment(paymentIntentId, shoppingCartId) : await GiftCardService.BuyGiftCard(giftCardPurchaseDetails);

				// 1. (completed) Payment is fulfilled and gift card and order is placed/processed succefully.
				// or 2. (requiresInternalHandling) Payment is fulfilled. But gift card or order is not yet placed/processed (Internal procedure).
				if (result.completed || result.requiresInternalHandling) {
					this.$eventBus.$emit('snackbar', new Snackbar({ text: result.message, type: 'success' }));
					this.purchaseCompleted(result);
					this.goToStep(-1); // Completed step
				}

				// Payment requires additional actions (3D Secure)
				else if (result.paymentRequiresAction && result.paymentIntentClientSecret) {
					const { error, paymentIntent } = await this.$root.stripe.handleCardAction(result.paymentIntentClientSecret);

					// The card action has been handled.
					// Confirm the gift card payment.
					if (!error) this.submitPurchase(null, paymentIntent.id, result.shoppingCartId);
					// @TODO: Show error from Stripe.js in payment form
					else {
						this.$eventBus.$emit(
							'snackbar',
							new Snackbar({
								text: error.message,
								type: 'error',
								closeButton: true
							})
						);
					}
				}

				// Payment failed
				else {
					this.$eventBus.$emit(
						'snackbar',
						new Snackbar({
							text: result.message,
							type: 'error',
							closeButton: true
						})
					);
				}
				this.loading--;
			}
		}
	},
	created() {
		if (!this.giftcard) {
			// Allow preset og amount as a url parameter
			this.giftcard = new GiftCardPurchaseDetails({
				amount: this.getAmountFromUrlParameter(this.$route.query.amount),
				deliveryMethod: this.getDeliveryMethodFromurlParameter(this.$route.query.deliveryMethod)
			});
		}
	},
	watch: {
		// Make sure we display the current step inside the viewport
		currentStep: function(step) {
			const googleAnalytics = this.$google;
			setTimeout(function() {
				if (step > 0) {
					const menuHeight = 80;
					const element = document.getElementById('buy-giftcard-step-' + step);
					const elementOffsetTop = element.getBoundingClientRect().top;
					let offsetTop = (offsetTop = Math.abs(elementOffsetTop + window.scrollY) - menuHeight);
					window.scrollTo({
						top: offsetTop,
						left: 0,
						behavior: 'smooth'
					});

					let virtualPageView = null;

					// Google analytics
					switch (step) {
						case 2:
							virtualPageView = {
								title: 'Kjøp gavekort - personlig hilsen',
								url: '/kjop-gavekort/personlig-hilsen'
							};
							break;
						case 3:
							virtualPageView = {
								title: 'Kjøp gavekort - Levering',
								url: '/kjop-gavekort/levering'
							};
							break;
						case 4:
							virtualPageView = {
								title: 'Kjøp gavekort - Oppsummering',
								url: '/kjop-gavekort/oppsummering'
							};
							break;
						case 5:
							virtualPageView = {
								title: 'Kjøp gavekort - Betaling',
								url: '/kjop-gavekort/betaling'
							};
							break;
					}

					// Send google analytics virtual page view for each step
					if (virtualPageView) {
						googleAnalytics.sendPageView(virtualPageView.title, virtualPageView.url);
					}
				}
			}, 600);

			// Reset 'requiresInternalHandling'
			if (step > 0 && this.requiresInternalHandling) {
				this.requiresInternalHandling = false;
			}
		}
	}
};
</script>
